// src/components/AboutUs.js
import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <div className="about-us">
        <h2 className="about-title">About Kothari Luggage Mall</h2>
        <div className="about-content">
          <p>
            Established in the year 1982, we, 'Kothari Group, Nasik', are a renowned manufacturer, supplier and trader of fine quality Multipurpose Bags. In our range, we have Luggage Bags, Office Bags, Travel Bags, School Bags, Briefcases and other types of Bags, that are manufactured using high-grade fabric. Clients appreciate our bags for being light weight, durable, impact resistant, water resistant and having high usability. These bags are used in Corporate Establishments, Commercial Establishments, Schools, House Hold and Offices. Further, we are also a dealer of Samsonite, VIP, Alfa, Calton, Carlite and many more brands.
          </p>
          <p>
            Our production unit is spread in an extensive plot area of 10,000 sq. ft. and has most advanced line of stitching, cutting and designing machinery. Using such advanced machines, our professionals fabricate high quality bags in standard and customized range. We offer customization on the basis of size, shapes, patterns, raw material and other parameters. Clients can avail bulk orders in minimum possible turnaround time.
          </p>
          <p>
            Our director, 'Mr. Kamlesh Kothari', is a highly experienced and qualified businessman. Using his in-depth knowledge of the domain, he has always guided us to serve the clients in most efficient manner and has helped us carve a niche in the industry.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;